var React = require('react');

function AboutUs (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.287 1.307 12 1.188l-.288.12-7.065 2.931-.286.119-.119.286-2.935 7.055-.12.287.12.288 2.936 7.098.119.288.287.119 7.043 2.914.286.118.286-.117 7.085-2.917.289-.119.119-.288 2.935-7.096.12-.287-.12-.288-2.935-7.055-.12-.286-.285-.119-7.065-2.932zM2.811 11.988l2.697-6.482L12 2.812l6.49 2.694 2.698 6.482-2.698 6.52-6.51 2.68-6.47-2.676-2.699-6.524zM11 11.5a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm1-4a1 1 0 1 0 .001 2 1 1 0 0 0 0-2z","fill":"#fff"}));
}

AboutUs.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = AboutUs;

AboutUs.default = AboutUs;
